export const GOOGLE_API_KEY: string = process.env.REACT_APP_GOOGLE_MAP_API_KEY!;
export const GOOGLE_MAP_ID: string = process.env.REACT_APP_GOOGLE_MAP_ID || "YOUR_MAP_ID_HERE";